/**
 * SEO-friendly URL builders.
 * Pattern: /{base}/{title-slug}-{shortid}
 * Backend resolves the URL by matching the trailing shortid against the UUID prefix.
 */

export function slugify(text) {
  if (!text) return '';
  return String(text)
    .toLowerCase()
    .replace(/[^\w\s-]/g, '')
    .trim()
    .replace(/[-\s]+/g, '-')
    .substring(0, 60);
}

/** Generate /jobs/{slug}-{shortid} from a job object */
export function buildJobUrl(job) {
  if (!job) return '/job-board';
  const slug = slugify(job.title);
  const shortid = (job.id || '').split('-')[0];
  return slug ? `/jobs/${slug}-${shortid}` : `/jobs/${job.id}`;
}

/** Generate /courses/{slug} from a course object (LMS already supports slug lookup) */
export function buildCourseUrl(course) {
  if (!course) return '/courses';
  const slug = course.slug || slugify(course.title);
  return `/courses/${slug || course.id}`;
}

/** Generate /events/{slug} from an event object (backend resolves slug or UUID) */
export function buildEventUrl(event) {
  if (!event) return '/events';
  return `/events/${event.slug || event.id}`;
}
